export default __webpack_public_path__ + "static/agua-fresca-mobile-5f955bbd98c89103e8f1a1dd2bc4bb15.png";